import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { find } from 'lodash';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  usuariosInRequest,
  deleteUsuario,
  findUsuario,
} from '~/store/modules/usuario/actions';

import UsuarioForm from './form';

function UsuarioList() {
  const usuario = useSelector((state) => state.usuario);

  const typeUser = useMemo(
    () => [
      { label: 'U', value: t('s.cadastro.usuario.usuario') },
      { label: 'F', value: t('s.cadastro.usuario.frentista') },
      { label: 'A', value: t('s.cadastro.usuario.usuariofrentista') },
    ],
    []
  );

  const statusUser = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const custom = useMemo(
    () => [
      {
        id: 'ididioma',
        label: 'Idioma',
        type: 'text',
      },
      {
        id: 'idperfil',
        label: 'ID Perfil',
        type: 'number',
      },
      {
        id: 'idusuario',
        label: 'ID Usuário',
        type: 'number',
      },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'emailusuario',
        label: t('s.cadastro.usuario.emailusuario'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'nomeperfil',
        label: t('s.cadastro.usuario.idperfil'),
        filter: {
          type: 'autocomplete',
        },
      },
      {
        id: 'tipousuario',
        label: t('s.cadastro.usuario.tipousuario'),
        formatter: (v) => find(typeUser, (s) => s.label === v).value,
        styled: (v) => (v === 'F' ? { background: '#ccc' } : {}),
        filter: {
          type: 'select',
          options: typeUser,
        },
      },
      {
        id: 'statususuario',
        label: t('s.cadastro.usuario.statususuario'),
        formatter: (v) => find(statusUser, (s) => s.label === v).value,
        filter: {
          type: 'select',
          options: statusUser,
        },
      },
    ],
    [typeUser, statusUser]
  );

  return (
    <UnidataTable
      read={usuariosInRequest}
      remove={deleteUsuario}
      redux={usuario}
      header={header}
      custom={custom}
      detach="nomeusuario"
      keys="idusuario"
      form={UsuarioForm}
      find={findUsuario}
    />
  );
}

export default UsuarioList;
